function ClosingBand() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20still%20life%2C%20scattered%20paper%20clippings%20and%20folded%20newspaper%20on%20a%20rustic%20wood%20desk%2C%20a%20brass%20desk%20lamp%20and%20reading%20glasses%2C%20deep%20terracotta%20and%20amber%20and%20warm%20cream%20tones%2C%20soft%20shadow%20play%2C%20shallow%20depth%20of%20field%2C%20atmospheric%20minimal%20composition%2C%20no%20people%2C%20no%20legible%20text&width=1600&height=640&seq=closing-band-01&orientation=landscape"
        alt="追踪口径背景"
        className="h-[420px] w-full object-cover md:h-[520px]"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/60"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <div className="max-w-2xl">
            <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-3 py-1.5 text-xs font-semibold text-foreground-950">
              <i className="ri-edit-line"></i>
              本站追踪口径
            </p>
            <h2 className="font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              追踪的是“公开讨论”，不是任何个人的私密信息
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-background-100/90">
              关于四一爆料身份背景的讨论本就公开存在，本站只做汇总与索引，便于大家看清来路、评估可信度。本页不发布、不推定任何个人隐私，若确有真名与照片被证实，也请以当事人与权威信源的说法为准。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#top"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
              >
                返回页首继续阅读
              </a>
              <a
                href="#index"
                className="whitespace-nowrap rounded-md bg-background-50/95 px-6 py-3 text-center text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-50"
              >
                再次核对线索索引
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ClosingBand;